import { render } from "./ExternalAnchor.vue?vue&type=template&id=0923fe29&scoped=true&ts=true"
import script from "./ExternalAnchor.vue?vue&type=script&lang=ts"
export * from "./ExternalAnchor.vue?vue&type=script&lang=ts"

import "./ExternalAnchor.vue?vue&type=style&index=0&id=0923fe29&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0923fe29"]])

export default __exports__